export default __webpack_public_path__ + "static/media/person.6597f72d.svg";